import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { VehicleFleetIcon } from '@moia-dev/pace-icons'
import { FleetsAreaRoutes } from './FleetsAreaRoutes'

export const FleetsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetsAreaRoutes.route}
      Icon={VehicleFleetIcon}
    />
  )
}
